import { MaterialConfiguration } from './material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class UnknownCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'unknown';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/ebook.png';
        this.classType = 'Unknown';
        this.subtitle = null;
        this.multiContent = false;
        this.expired = false;
        this.clickable = !this.expired;
        this.action = LinkActions.DOWNLOAD;
        this.links = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/unknown-card-configuration.ts